#import "@/apollo/fragments/Annotation.gql"

query ComputedDeliverablesAnnotations(
    $campaignId: ID!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]!
    $annotationType: AnnotationType
) {
    computedDeliverables(campaignId: $campaignId, computedDeliverableIdentifiers: $computedDeliverableIdentifiers) {
        _id
        annotations(annotationType: $annotationType) {
            ...Annotation
        }
    }
}
